import React, {useContext, useEffect} from 'react'
import headbandContext from 'contexts/headband'
import "./parcoursFormation.scss"
import { Switch, Route, useRouteMatch } from "react-router-dom";
import HeadbandTitle from 'components/headband/headbandTitle'
import ButtonsContainer from 'components/buttons/buttonsContainer'
import RouteWithSubRoutes from "components/routes/routeWithSubRoutes";
import GuidePratique from './guidePratique/guidePratique';
export default function ParcoursFormation({routes}) {
    const {setHeadband} = useContext(headbandContext)
    useEffect(() => {
        setHeadband({
            title :  "Mon parcours de formation",
            icon : "picto parcours de formation - v2.svg",
            color : "bckDarkBlue"
        })
    }, [])
    
    const buttons = [
        {
            title : "Le guide pratique",
            icon : "picto guide pratique - v2.svg",
            buttonBackground : "bckDarkBlue80",
            page : "/accueil/parcours_formation/guide_pratique",
            right : "600px",
            delay : "0"
        },
        {
            title : "Les formations",
            icon : "picto actu formations - v2.svg",
            buttonBackground : "bckDarkBlue80",
            page : "/accueil/parcours_formation/formations",
            left : "600px",
            delay : "0"
        },
        {
            title : "Comment m'inscrire à une formation",
            icon : "picto inscription - v2.svg",
            buttonBackground : "bckDarkBlue80",
            page : "/accueil/parcours_formation/inscription_formation",
            right : "600px",
            delay : "200"
        },
        {
            title : "trombinoscope de l'équipe",
            icon : "picto_trombinoscope.svg",
            buttonBackground : "bckDarkBlue80",
            page : "/accueil/parcours_formation/trombinoscope_formation",
            left : "600px",
            delay : "200"
        },
    ]
    return (
        <div className="w100 h100 page" id="parcoursFormation">
            <div className='w100' style={{padding : "100px"}}>
                <ButtonsContainer buttons={buttons}/>
            </div>        
        </div>
    )
}
